// Silences every browser console method outside local development.
//
// `npm start` (localhost) runs with NODE_ENV === 'development' and keeps logs.
// Every deployed build (dev / QA / prod via `react-scripts build`) runs with
// NODE_ENV === 'production', so all console output is replaced with no-ops to
// avoid leaking internal data.
//
// This module must be the FIRST import in src/index.js so it runs before any
// other module's top-level code can log.

const CONSOLE_METHODS = [
  'log',
  'info',
  'debug',
  'warn',
  'error',
  'trace',
  'table',
  'dir',
  'dirxml',
  'group',
  'groupCollapsed',
  'groupEnd',
  'time',
  'timeEnd',
  'timeLog',
  'timeStamp',
  'count',
  'countReset',
  'assert',
  'profile',
  'profileEnd',
]

const noop = () => {}

// if (process.env.NODE_ENV !== 'development' && typeof window !== 'undefined' && window.console) {
  CONSOLE_METHODS.forEach((method) => {
    try {
      window.console[method] = noop
    } catch (e) {
      // Some environments expose read-only console methods; ignore them.
    }
  })
// }
